const doc = [({"ja":({"signInFormDescription":"オペレーターとやり取りしているメールアドレスでログインしてください。\n ログイン後に [ 予約申込 | 検索 ] ができます。 ", "signInFormPasswordDescription":"新規登録するパスワード、または登録済みのパスワードを入力してください"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;